<script>
    import { client, gql } from "../../GraphQL.svelte";
    import { approveContribution, rejectContribution } from "../../Participaid.svelte";
    import { faTrash } from '@fortawesome/free-solid-svg-icons';
    import { pencil } from 'svelte-awesome/icons';
    import Icon from 'svelte-awesome';
    import ProjectLib from "../../models/participaid/Project.js";
    import Util from "../../lib/util.js";

    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
    import Dialog, {Title, Content, Actions, InitialFocus} from '@smui/dialog';
    import {Label} from '@smui/button';
    import Button from "../form/Button.svelte";
    import TextField from '../form/TextField.svelte';

    import Name from "../Name.svelte";
    import Overlay from "../Overlay.svelte";
    import ProfilePicture from "../ProfilePicture.svelte";
    import TimeAgo from "../TimeAgo.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import Notification from "../Notification.svelte";
    import EditEntryDialog from "../dialogs/EditEntryDialog.svelte";

    import ReviewStatusSymbol from "./ReviewStatusSymbol.svelte";
    import EntryTags from "../form/EntryTags.svelte";
    import ContributionValue from "./ContributionValue.svelte";

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let project;
    export let model;
    export let isOwner;
    export let contributor;
    export let editable = true;
    export let myUserId;

    let deleting = false;
    let deletionRequest;
    let deleted = false;
    let isMine = myUserId == contributor.user.id;
    let isOwnerOrMine = isOwner || isMine;
    let showEditDialog = false;

    let rejectionReasonDialog;
    let rejectionReason = "";
    let editSuccessMsg = "";

    // notification messages

    let approveSuccessMsg;
    let approveErrMsg;

    let rejectSuccessMsg;
    let rejectErrMsg;

    let deleteSuccessMsg;
    let deleteErrMsg;

    $: isPendingState = !["ACCEPTED", "REJECTED", "NONE"].includes(model.review.acceptanceStatus);
    $: isRejected = model.review.acceptanceStatus == "REJECTED";
    $: isLive = project && ProjectLib.isLive(project);
    $: isDraft = !isLive;
    $: projectId = project && project.id;
    $: projectField = (project
        && project.fields
        && model
        && model.projectField
        && Util.indexBy(project.fields, "id")
        [model.projectField.id]);

    const DELETE_QUERY = gql`
        mutation($id: Guid!, $projectId: Guid!) {
            deleteContribution(id: $id, projectId: $projectId) {
                id
            }
        }
    `;

    function deleteIt() {
        if (confirm("Are you sure you want to delete this entry?")) {
            deletionRequest = client.mutate({
                mutation: DELETE_QUERY,
                variables: {
                    projectId,
                    id: model.id
                }
            })
            .then(res => {
                console.log(`successfully deleted Entry`);
                deleted = true;
                deleteSuccessMsg = "Successfully deleted contribution";
                dispatch("deleted", model);
            })
            .catch(err => {
                deleteErrMsg = "Failed to delete contribution";
            })
        }
    }

    function handleEdited(evt) {
        editSuccessMsg = "Successfully updated entry";
        showEditDialog = false;
        model = evt.detail;
        contributor = model.contributor;
    }

    function approve() {
        approveContribution(projectId, model.id)
            .then(res => {
                console.log(`[ContributionTableItem] received confirmation of approved contribution`);
                console.log(res);

                model = {...model, ...res.data.approveContribution};

                approveSuccessMsg = "Approved contribution";
                dispatch("approved", model);
            })
            .catch(err => {
                approveErrMsg = "Failed to approve contribution";
            })
    }

    function reject() {
        rejectContribution(projectId, model.id, rejectionReason)
            .then(res => {
                console.log(`[ContributionTableItem] received confirmation of rejected contribution`);
                console.log(res);

                model = {...model, ...res.data.rejectContribution};

                rejectSuccessMsg = "Successfully rejected contribution";
                dispatch("rejected", model);
            })
            .catch(err => {
                rejectErrMsg = "Failed to reject contribution!";
            })
    }

    function reload() {

    }
</script>

<div class="contribution-lister-item">

    <span class="json-source" style="display: none;">
        {#if model}
            {JSON.stringify(model)}
        {/if}

        {#if projectField}
            {JSON.stringify(projectField)}
        {/if}
    </span>

    {#if deleted}
<!--        <div class="contribution-table-item deleted" style="width: 100%">-->
<!--            <div class="deleted-entry-text" style="width: 100%; text-align: center">-->
<!--                <a style="color: #CCC; font-weight: bold;">restore entry</a>-->
<!--            </div>-->
<!--        </div>-->
    {:else}
        <div class="contribution-table-item">

            <!-- the right part -->
            <div>

                <!-- status -->
                <div class="status-cell">
                    <LoadingModal
                            show={deleting}
                            global={false}
                            background="darken"/>

                    <div class="entry-meta">

                        <!--
                        {#if model.tags && model.tags.trim().split(",").length}
                            <EntryTags
                                current={model.tags.split(",")}
                                border={false}
                                icon={false}
                                disable
                                placeholder=""
                                available={[]}/>
                        {/if}
                        -->

                        <!-- person, left part -->
                        <div class="avatar-cell">
                            {#if contributor}
                                <ProfilePicture
                                        user={contributor.user}
                                        seed={contributor.id}
                                        style="width: 32px; height: 32px;"
                                        size="3"
                                />
                                <Name model={contributor.user} last={true}/>
                            {:else}
                                ...
                            {/if}
                        </div>
                        <span class="entry-id">#{model.id}</span>
                        <span> - entered <TimeAgo date={new Date(model.creationTime)} class="entry-date"/> </span>
                        <ReviewStatusSymbol
                                model={model.review}
                                style="margin-left: 10px"
                        />
                    </div>
                </div>

                <!-- body -->
                <div class="body-cell" style="text-align: left">
                    <div class="entry-description">
                        <div class="input-type">{model.projectField.name}</div>
                        <p>{model.description}</p>
                    </div>

                    <!-- edit button -->
                    {#if isPendingState}
                        <button on:click={() => showEditDialog = true} class="action-button contribution-edit-button">
                            <Icon data={pencil}/>
                        </button>
                    {/if}

                    <!-- value -->
                    <div class="contribution-value">
                        <ContributionValue
                                model={model.inputValue}
                                field={projectField}
                                projectId=""
                                {contributor}
                                style="display: flex; flex-direction: column; justify-content: center;"
                        />
                    </div>
                </div>

                <!-- bottom part -->
                <div>

                    <!-- actions -->
                    <!-- TODO: refactorbuttons into ownclass -->
                    <div class="actions-cell">
                        {#if !editable || !isOwnerOrMine}
                        <!-- nothin -->
                        {:else}
                            {#if isPendingState}
                                <!-- TODO: API does not support deleting after review -->
                                <button on:click={deleteIt} class="action-button contribution-delete-button">
                                    <Icon data={faTrash}/>
                                </button>

    <!--                            <button on:click={() => showEditDialog = true} class="action-button contribution-edit-button">-->
    <!--                                <Icon data={pencil}/>-->
    <!--                            </button>-->
                            {/if}

                            {#if isOwner}
                            <!-- TODO: API does not support adjusting a contribution if its already reviewed -->
                                {#if !isRejected}
                                <!--                    <button on:click={() => rejectionReasonDialog.open()}>Reject...</button>-->
                                {/if}

                                {#if isPendingState}
                                    <button class="action-button contribution-reject-button" disabled={isDraft} on:click={() => rejectionReasonDialog.open()}>Reject</button>
                                    <Button class="action-button contribution-approve-button" disabled={isDraft} on:click={approve} style="margin-left: 20px">Approve</Button>
                                {/if}
                            {/if}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    {/if}

    <Dialog bind:this={rejectionReasonDialog} aria-labelledby="simple-title" aria-describedby="simple-content">
        <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
        <Title id="simple-title">Reject contribution</Title>
        <Content id="simple-content">
            <p>Please specify a reason for rejection the user contribution.</p>
            <TextField
                    class="rejection-reason-text"
                    style="width: 100%"
                    textarea
                    bind:value={rejectionReason}
                    label="Description"
                    placeholder="Specify rejection reason..."
            />
        </Content>
        <Actions>
            <Button>
                <Label>Cancel</Label>
            </Button>
            <Button on:click={reject} disabled={!rejectionReason}>
                <Label>Reject</Label>
            </Button>
        </Actions>
    </Dialog>

    {#if showEditDialog}
        <Overlay background="darken" closable={true} on:close={() => showEditDialog = false} loaderBackground="transparent">
            <EditEntryDialog
                    meUserId={myUserId}
                    {isOwner}
                    {project}
                    contribution={model}
                    targetUserId={contributor.user.id}
                    on:updated={handleEdited}
            />
        </Overlay>
    {/if}

    <Notification message={approveSuccessMsg} type="success"/>
    <Notification message={approveErrMsg} type="error"/>

    <Notification message={rejectSuccessMsg} type="success"/>
    <Notification message={rejectErrMsg} type="error"/>

    <Notification message={deleteSuccessMsg} type="success"/>
    <Notification message={deleteErrMsg} type="error"/>

    <Notification message={editSuccessMsg} type="success"/>

</div>

<style>
    .contribution-table-item {
        margin: auto;
        width: 800px;
        margin-bottom: 50px;
    }

    .contribution-table-item .body-cell {
        background: white;
        padding: 25px;
        display: flex;
        flex-direction: row;
        font-size: 16px;
        text-transform: capitalize;
    }

    .contribution-table-item .avatar-cell {
        display: flex;
        flex: 1;
        align-items: center;
        align-self: flex-start;
    }

    .contribution-table-item .avatar-cell img {

    }

    .contribution-table-item .entry-meta {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .contribution-value {
        text-align: right;
    }

    :global(.contribution-table-item .entry-id),
    :global(.contribution-table-item .entry-date) {
        color: #CCC;
        text-transform: uppercase;
        font-size: 80%;
    }

    :global(.contribution-table-item .body-cell .entry-description) {
        font-size: 110%;
        font-weight: 500;
        flex: 1;
        //background: white;
    }

    :global(.contribution-table-item .body-cell .entry-description .input-type) {
        background: #ddd;
        padding: 4px;
        text-transform: uppercase;
        font-size: 12px;
        display: inline-block;
    }

    :global(.contribution-table-item .body-cell .entry-description p) {
        margin-top: 3px;
    }

    :global(.contribution-table-item .actions-cell) {
        text-align: right;
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .action-button {
        margin-left: 5px;
    }

    .contribution-delete-button, .contribution-reject-button {
        background: 0;
        border: 2px solid #C00;
        color: #C00;
    }

    .contribution-edit-button {
        background: 0;
        border: 2px solid transparent;
        color: #333;
        margin-right: 25px;
    }

    .contribution-approve-button {
        //background: green;
        //border: 2px solid #C00;
        color: white;
        font-weight: bold;
        margin-left: 20px;
    }

    .contribution-approve-button[disabled], .contribution-reject-button[disabled] {
        opacity: 0.3;
    }

    :global(.contribution-table-item-snackbar .snackbar-success .mdc-snackbar__surface) {
        background: green;
        color: white;
        font-weight: bold;
    }
</style>